import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { actions } from "../../../../store/modules";
import i18n from "../../../../plugins/i18n/i18n";
import parsePhoneNumber from 'libphonenumber-js'
import { Col, Input, Row, List, Card, Spin, Modal, notification as Notification } from 'antd';
import { SearchOutlined, EditOutlined, DeleteOutlined, UserAddOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { errorMessageNotification, isMobile } from "../../../../helpers";

const { confirm } = Modal;
const type = "contact";

class ContactList extends Component {

    constructor(props) {
        super(props);

        this.endpoint = { keyOne: "contacts" };
        this.state = {
            isResponsive: false,
            data: null,
            filteredData: null,
            total: 0,
            loadings: {
                data: false
            }
        };
    }

    componentWillMount() {
        if (isMobile()) {
            this.setState({
                isResponsive: true,
            });
        }

        this.getData();

    }

    getData = () => {

        let { loadings } = this.state;
        loadings.data = true;

        this.setState({ loadings });

        this.props.dispatch(actions.definitions.getData({
            ...this.endpoint
        })).then(response => {
            loadings.data = false;

            response.data.push({
                title: 'Kişi Ekle',
                phoneNumber: "+90 532 211 22 22",
                address: "Adana, Türkey",
                isNew: true,
                name: "   ",
                id: -1,
            });

            let sortedData = response.data.sort((a, b) => (a.name > b.name ? 1 : -1));

            this.setState({
                data: sortedData, filteredData: sortedData, total: response.total, loadings
            });


        })
            .catch(error => {

                loadings.data = false;

                this.setState({
                    loadings
                });

                Notification.error({
                    message: i18n.t(`error`, {
                        lng: this.props.currentLanguage,
                    }),
                    description: errorMessageNotification(error),
                    className: "general-notification",
                    placement: "bottomLeft",
                    duration: 100,
                });

            })
    }

    onChangeSearchbox = (e) => {

        let { data, filteredData } = this.state;

        filteredData = data.filter(item => (
            item.id === -1 ||
            item.name.toLowerCase().includes(e.target.value) ||
            item.lastname.toLowerCase().includes(e.target.value) ||
            (item.address && item.address.toLowerCase().includes(e.target.value)) ||
            item.phoneNumber.toLowerCase().includes(e.target.value)
        ));

        this.setState({ filteredData })

    }

    onDeleteConfirm = (id) => {

        let _this = this;
        let endpoint = { keyOne: `${type}`, idOne: id };

        confirm({
            centered: true,
            title: 'Kişi Silme',
            icon: <ExclamationCircleOutlined />,
            content: 'Bu işlem bir daha geri alınamaz.',
            okText: "Sil",
            okType: "danger",
            onOk() {
                _this.props
                    .dispatch(
                        actions.definitions["deleteData"]({
                            ...endpoint,
                        })
                    )
                    .then((response) => {
                        _this.getData()
                        Notification.success({
                            message: errorMessageNotification(response),
                            className: "general-notification",
                            placement: "bottomLeft",
                            duration: 3,
                        });
                    }

                    );
            },
            onCancel() {
            },
        });

    }

    render() {

        let { loadings, filteredData, total } = this.state;

        return (

            <Fragment>

                {
                    loadings.data &&
                    <div className="ant-loading loading-content">
                        <Spin
                            tip={`${i18n.t(`loading`, {
                                lng: this.props.currentLanguage,
                            })}`}
                        />
                    </div>
                }

                {
                    !loadings.data &&
                    <div className='list-container contacts'>
                        <div className='page-header'>
                            <Row>
                                <Col xs={8} sm={8} md={8} lg={8} xl={8}>
                                    <h1>
                                        <span className='count'>{total}</span>
                                        <span className='label'>Kişi Bulundu</span>
                                    </h1>
                                </Col>
                                <Col xs={16} sm={16} md={16} lg={16} xl={16}>
                                    <div className='searchbox'>
                                        <Input placeholder='Arama...'
                                            width={300}
                                            prefix={<SearchOutlined />}
                                            onChange={(e) => this.onChangeSearchbox(e)}
                                        ></Input>
                                    </div>
                                </Col>
                            </Row>
                        </div>

                        <List
                            className='content-list'
                            grid={{
                                gutter: 16,
                                xs: 3,
                                sm: 3,
                                md: 3,
                                lg: 3,
                                xl: 3,
                                xxl: 3,
                            }}
                            dataSource={filteredData}
                            renderItem={(item) => (

                                <List.Item
                                >
                                    {
                                        item.isNew ?

                                            <Card
                                                hoverable
                                                title={item.title}
                                                className='new-item'
                                                onClick={() => this.props.history.push(`/app/contacts/create`)}
                                            >
                                                <div><UserAddOutlined /></div>

                                            </Card>
                                            :
                                            <Card
                                                hoverable
                                                title={`${item.name} ${item.lastname}`}
                                                actions={[
                                                    <EditOutlined key="edit" onClick={() => this.props.history.push(`/app/contacts/edit/${item.id}`)} />,
                                                    <DeleteOutlined key="delete" onClick={() => this.onDeleteConfirm(item.id)} />,
                                                ]}

                                            >
                                                <div className='content-first'>{parsePhoneNumber("+" + item.phoneNumber).formatInternational()}</div>
                                                <div className='content-second'>{item.address}</div>

                                            </Card>

                                    }
                                </List.Item>
                            )}
                        />

                    </div>
                }
            </Fragment>

        );
    }
}

const mapStateToProps = ({ account }) => ({ ...account });
export default connect(mapStateToProps)(ContactList);


// WEBPACK FOOTER //
// ./src/components/App/Views/Contact/ContactList.js